import React, { useMemo, useState } from "react";

/* ===== Подключение Картинок ===== */
import act1 from "../../../assets/images/actionss1.png";
import act2 from "../../../assets/images/actionss2.png";
import act3 from "../../../assets/images/actionss3.png";

/* ===== Подключение стилей ===== */
import s from "./Actions.module.scss";

/* ===== Модалка ===== */
import Modal from "../../ui/Modal/Modal";

// ВАЖНО: тут подключи свою форму
import FormBase from "../../ui/Forms/FormBase";

function Actions() {
  const items = useMemo(
    () => [
      {
        id: "act-1",
        title: "Рекомендуйте партнёров",
        subtitle: "За подключённого клиента по вашей рекомендации - дополнительная выгода к следующей поставке или денежное вознаграждение на ваш выбор.",
        img: act1,
      },
      {
        id: "act-2",
        title: "Социальная поддержка",
        subtitle: "Для клиентов пенсионного возраста - скидка 1 000 ₽ при заказе от 1 000 литров (по подтверждению статуса).",
        img: act2,
      },
      {
        id: "act-3",
        title: "Повторная поставка — дополнительные литры",
        subtitle: "При регулярной работе предоставляем до 100 литров топлива в подарок - в зависимости от объёма заказа.",
        img: act3,
      },
    ],
    []
  );

  const [active, setActive] = useState(null);

  const open = (item) => setActive(item);
  const close = () => setActive(null);

  return (
    <section className={s.actions} id="offers">
      <div className={`container ${s.container}`}>
        <div className={s.header}>
          <h2 className={s.title}>Актуальные предложения</h2>
          <p className={s.subtitle}>Выберите акцию — и оставьте заявку в 2 клика</p>
        </div>

        <div className={s.grid}>
          {items.map((item) => (
            <button
              key={item.id}
              type="button"
              className={s.card}
              onClick={() => open(item)}
              aria-label={`Открыть акцию: ${item.title}`}
            >
              <div className={s.media}>
                <img className={s.image} src={item.img} alt={item.title} />
              </div>

              <div className={s.meta}>
                <h3 className={s.cardTitle}>{item.title}</h3>
                <p className={s.cardSubtitle}>{item.subtitle}</p>

                <span className={s.cta}>
                  Оставить заявку <span className={s.arrow}>→</span>
                </span>
              </div>
            </button>
          ))}
        </div>
      </div>

      {/* ===== MODAL ===== */}
      <Modal isOpen={!!active} onClose={close} title={active?.title}>
        {active && (
          <div className={s.modalBody}>
            <p className={s.modalText}>
              Вы выбрали: <b>{active.title}</b>
              <br />
              <span className={s.modalHint}>{active.subtitle}</span>
            </p>

            {/* Тут подключаешь свою форму и передаёшь выбранную акцию */}
            {/* <FormBase promo={active} /> */}

            {/* Заглушка, чтобы было видно место формы */}
            <div className={s.formStub}>
              <FormBase promo={active} hideMessage={false} asModal />
            </div>
          </div>
        )}
      </Modal>
    </section>
  );
}

export default Actions;
